function useLoginValidation() {

    function isValidUser(user) {
        if (user === undefined || user === null || user === '')
            return 'El usuario no puede estar vacío.';
        if (user.length < 3)
            return 'El usuario debe tener al menos 3 caracteres.';
        return '';
    }

    return {isValidUser};
}

export default useLoginValidation;